import { render } from "./UpdateTemplateIsoPermissions.vue?vue&type=template&id=6891c114&scoped=true"
import script from "./UpdateTemplateIsoPermissions.vue?vue&type=script&lang=js"
export * from "./UpdateTemplateIsoPermissions.vue?vue&type=script&lang=js"

import "./UpdateTemplateIsoPermissions.vue?vue&type=style&index=0&id=6891c114&scoped=true&lang=scss"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.18.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6891c114"]])

export default __exports__